import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { OnlinestoresComponent } from './onlinestores.component';
const routes: Routes =[
  {
    path: '',
    children: [
      {
        path: 'onlinestores',
        component: OnlinestoresComponent,
        data: {
          title: "onlinestores",
          breadcrumb: "onlinestores"
        }
      }
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class OnlinestoresRoutingModule { }
